<div class="container-fluid ter-container nc"
style="flex: auto;">
<pools-layout [pools]="pools"></pools-layout>
</div>